import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { PhaseChangeEvent, InventoryReportsService } from 'app/modules/vehicle-inventory/services/inventory-reports.service';
import { AuthenticationService } from 'app/core/services/authentication/authentication.service';
import { Rest } from 'app/rest/rest_client';

import InventoryReportRequest = Rest.InventoryReportRequest; import { jsPDF } from 'jspdf';
import "jspdf-autotable";
import { ExcelService } from 'app/services/excel-service/excel.service';
import { SortEvent } from 'primeng/api';
import { table } from 'console';
import { DatePipe } from '@angular/common';
import { LoadingService } from 'app/services/loading-service/loading.service';
import { UserTimePipe } from 'app/components/shared/UserTimePipe';
import { TranslateService } from '@ngx-translate/core';
import * as XLSX from 'xlsx';
import { start } from 'repl';


@Component({
    selector: 'app-report-generator',
    templateUrl: './report-generator.component.html',
    styleUrls: ['./report-generator.component.css'],
    providers: [InventoryReportsService, ExcelService],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class ReportGeneratorComponent implements OnInit  {
  client: Rest.Client;

  @Output() phaseChange = new EventEmitter<PhaseChangeEvent>();

  @Input() report: PhaseChangeEvent;

  formData: any;
  reportRequest: InventoryReportRequest;

  tableData: any;
  tableDataFormatted: any; //data transformed to clasic json 

  display: boolean = false;
  columns: any[];
  values: Rest.ReportResponseItem[] = [];
  exportPDFColumns;

  // LICENSE REPORT DATA
  expirationDate: string;
  alarmDate: string;

  //INSURANCE REPORT DATA
  startDate: string;

  //FINES REPORT DATA
  startDateFines: string;
  endDateFines: string;

  // ITV REPORT DATA
  alarmDateMaintenances: string;


  dialogWidth = '70vw';
  colspanTest = '4';
  
  constructor(
    private inventoryReportsService: InventoryReportsService,
    private authenticationService: AuthenticationService,
    public excelService: ExcelService,
    private datePipe: DatePipe,
    private loadingService: LoadingService,
    private userTime: UserTimePipe,
    private translateService: TranslateService

  ) { }

  ngOnInit(): void {
    this.client = this.authenticationService.user.client;
    this.formData = this.report.formData;
  }

  ngOnChanges() {
    console.log(this.report.formData);
  }

  goBack() {
    // Will go back with the same form data and emitting a PhaseChangeEvent with pase 2 and all its form data

    this.phaseChange.emit({ phase: 2, reportData: this.report.reportData, formData: this.report.formData });
  }

  generateReport() {
    console.log('Generating report...'); //TODO: Eliminar console.log
    this.loadingService.increaseRESTOngoingRequestCounter();
    switch (this.report.reportData.reportType) {
      case 'DRIVERS_EXPIRATION':
        this.generateDriversExpirationReport();
        break;

      case 'INSURANCE_ACTIVE':
        this.generateInsuranceActiveReport();
        break;

      case 'VEHICLE_ACCESORY':
        this.generatevehicleAccesoryReport();
        break;

      case 'FINES':
        this.generateFinesReport();
        break;

      case 'VEHICLE_CONSUMPTION':
        this.generateConsumptionReport();
        break;

      case 'CARD':
        this.generateReportWithoutDates();
        break;

      case 'ITV_EXPIRATION':
        this.generateITVExpirationReport();
        break;

      case `VEHICLE_EXPIRATION`:
        this.generateFinesReport();
        break;

      case 'VEHICLE':
        this.generateReportWithoutDates();
        break;
      case 'NIIF':
        this.generateFinesReport();
        break;
      case 'DRIVER_ASSIGNMENT':
        this.generateFinesReport();
        break;
      case 'CECO':
        this.generateReportWithoutDates();
        break;
      case 'SINISTER':
        this.generateSinisterReport();
        break;
      case 'BREAKDOWN':
        this.generateBreakdownReport();
        break;
      case 'SANCTION':
        this.generateSanctionReport();
        break;
      default:
        console.error('Unsupported report type');
        break;
    }
    
  }

  generateDriversExpirationReport() {

    const filters = this.processFilters(this.formData);

    if (!this.alarmDate && !this.expirationDate) {
      alert('Please select a date.'); // Use a more user-friendly notification method as needed
      return;
    }

    const formattedAlarmDate = this.formatDate(this.alarmDate);
    filters['alarmDate'] = [formattedAlarmDate];

    const parameters = this.processParameters(this.formData.parameters);
    this.reportRequest = this.prepareReportRequest('DRIVERS_EXPIRATION', filters, parameters);

    this.sendReportRequest(this.reportRequest);
  }

  generateInsuranceActiveReport() {
    const filters = this.processFilters(this.formData);
    const parameters = this.processParameters(this.formData.parameters);
    this.reportRequest = this.prepareReportRequest(this.report.reportData.reportType, filters, parameters);

    this.sendReportRequest(this.reportRequest);
  }

  generatevehicleAccesoryReport() {
    const filters = this.processFilters(this.formData);
    const parameters = this.processParameters(this.formData.parameters);
    this.reportRequest = this.prepareReportRequest('VEHICLE_ACCESORY', filters, parameters);

    this.sendReportRequest(this.reportRequest);
  }

  generateFinesReport() {


    const formattedStartDate = this.formatDate(this.startDateFines);
    const formattedEndDate = this.formatDate(this.endDateFines);

    if (!formattedStartDate || !formattedEndDate) {
      alert(this.translateService.instant('tableManagement.reportsWizard.dateNotSelected'));
      return;
    }

    const filters = this.processFilters(this.formData);

    filters['startDate'] = [formattedStartDate];
    filters['endDate'] = [formattedEndDate];

    const parameters = this.processParameters(this.formData.parameters);
    this.reportRequest = this.prepareReportRequest(this.report.reportData.reportType, filters, parameters);

    this.sendReportRequest(this.reportRequest);
  }

  generateITVExpirationReport() {
    const alarmDate = this.formatDate(this.alarmDateMaintenances);

    if (!alarmDate) {
      alert('Please select an alarm date.'); // Use a more user-friendly notification method as needed
      return;
    }

    const filters = this.processFilters(this.formData);
    filters['alarmDate'] = [alarmDate];
    const parameters = this.processParameters(this.formData.parameters);
    this.reportRequest = this.prepareReportRequest(this.report.reportData.reportType, filters, parameters);

    this.sendReportRequest(this.reportRequest);
  }

  generateSinisterReport() {


    const formattedStartDate = this.formatDate(this.startDateFines);
    const formattedEndDate = this.formatDate(this.endDateFines);

    if (!formattedStartDate || !formattedEndDate) {
      alert(this.translateService.instant('tableManagement.reportsWizard.dateNotSelected'));
      return;
    }

    const filters = this.processFilters(this.formData);

    filters['startDate'] = [formattedStartDate];
    filters['endDate'] = [formattedEndDate];

    const parameters = this.processParameters(this.formData.parameters);
    this.reportRequest = this.prepareReportRequest(this.report.reportData.reportType, filters, parameters);

    this.sendReportRequest(this.reportRequest);
  }

  generateBreakdownReport() {

    const formattedStartDate = this.formatDate(this.startDateFines);
    const formattedEndDate = this.formatDate(this.endDateFines);

    if (!formattedStartDate || !formattedEndDate) {
      alert(this.translateService.instant('tableManagement.reportsWizard.dateNotSelected'));
      return;
    }

    const filters = this.processFilters(this.formData);

    filters['startDate'] = [formattedStartDate];
    filters['endDate'] = [formattedEndDate];

    const parameters = this.processParameters(this.formData.parameters);
    this.reportRequest = this.prepareReportRequest(this.report.reportData.reportType, filters, parameters);

    this.sendReportRequest(this.reportRequest);
  }

  generateSanctionReport() {
    const formattedStartDate = this.formatDate(this.startDateFines);
    const formattedEndDate = this.formatDate(this.endDateFines);

    if (!formattedStartDate || !formattedEndDate) {
      alert(this.translateService.instant('tableManagement.reportsWizard.dateNotSelected'));
      return;
    }

    const filters = this.processFilters(this.formData);
    filters['startDate'] = [formattedStartDate];
    filters['endDate'] = [formattedEndDate];

    const parameters = this.processParameters(this.formData.parameters);
    this.reportRequest = this.prepareReportRequest(this.report.reportData.reportType, filters, parameters);
    this.sendReportRequest(this.reportRequest);
  }

  generateReportWithoutDates() {
    const filters = this.processFilters(this.formData);
    const parameters = this.processParameters(this.formData.parameters);
    this.reportRequest = this.prepareReportRequest(this.report.reportData.reportType, filters, parameters);

    this.sendReportRequest(this.reportRequest);
  }

  private formatDate(date: Date | string): string {
    if (!date) return null;
    
    const dateObj = new Date(this.userTime.toUTCISOString(date));
    return dateObj.toISOString();
  }

  private processFilters(formData: any): { [key: string]: any } {
    const filters = {};

    Object.keys(formData).forEach(key => {
      if (key !== 'parameters') {
        let value = formData[key];

        // Check if the value is an array and has at least one non-null item
        if (Array.isArray(value)) {
          value = value.filter(item => item != null && (typeof item !== 'object' || item.id != null));
          if (value.length > 0) {
            filters[key] = value.map(item => typeof item === 'object' && item.id ? item.id : item);
          }
        }
        // For non-array values, check if they're non-null/undefined and not an empty string
        else if (value != null && value !== '') {
          filters[key] = [typeof value === 'object' && value.id ? value.id : value];
        }
      }
    });

    return filters;
  }

  private processParameters(parameters: any): string[] {
    return Array.isArray(parameters) ? parameters : [parameters];
  }

  private prepareReportRequest(reportType: string, filters: any, parameters: string[]): InventoryReportRequest {
    return {
      report: {
        client: { id: this.client.id },
        reportType
      },
      filters,
      parameters
    } as InventoryReportRequest;
  }

  sendReportRequest(reportRequest: InventoryReportRequest) {
    this.inventoryReportsService.generateReport(reportRequest).then(resp => {
      this.loadingService.decreaseRESTOngoingRequestCounter();
      if (resp == undefined || resp == null) {
        //TODO: Translate message
        alert('No se han encontrado datos para los parámetros seleccionados. Por favor, intente con otros parámetros.');
      }
      this.tableData = resp;

      console.log('Report generated:', this.tableData);

      //table columns
      this.columns = Object.keys(this.tableData[0]).map(key => ({ header: this.tableData[0][key].field, field: key, status: this.tableData[0][key].status }));
      //full width dialog
      if (this.columns?.length > 6) {
        this.dialogWidth = '95vw';
      }

      this.tableDataFormatted = this.formatTableData(this.tableData)
      //pdf columns
      this.exportPDFColumns = this.columns.map(col => ({
        title: col.header,
        dataKey: col.field
      }));

      // Handle successful report generation
      // console.log(JSON.stringify(this.tableDataFormatted));
      this.display = true;
    }).catch(error => {
      console.error('Error generating report:', error);
      this.loadingService.decreaseRESTOngoingRequestCounter();
    });
  }

  exportPdf() {
    let doc = new jsPDF('p', 'pt');
    // let pdfFontSize = 8
    //doc.addPage('a2');
    //screen orientation configuration
    if (this.exportPDFColumns.length > 5) {
      doc = new jsPDF('landscape');
    }
    else {
      doc = new jsPDF('p', 'pt');
    }
    const styles = {
      theme: 'grid',
      styles: { overflow: 'linebreak', fontSize: 8 },
      headStyles: { fillColor: [220, 53, 69], textColor: [255, 255, 255], fontSize: 7, overflow: 'linebreak' },

    };
    doc['autoTable']({
      columns: this.exportPDFColumns,
      body: this.tableDataFormatted,
      margin: { top: 5, right: 5, bottom: 5, left: 5 },
      ...styles,
      tableWidth: 'wrap',
      horizontalPageBreak: true,
    });

    let fileName = String(this.report.reportData.name).trim();
    if(this.report.reportData.reportType === 'NIIF') {
      fileName = String(this.report.reportData.name + "_" + this.translateService.instant('reportsWizard.niifTypes.' + this.formData.type)).trim();
    }

    doc.save(fileName + "_" + this.datePipe.transform(new Date(), 'yyyyMMddHHmmss') + ".pdf");
  }

  exportExcel() {
   

    const excelData = this.tableData.map((row) => {
      const transformedRow: Record<string, any> = {};
  
      Object.keys(row).forEach((key) => {
        const column = row[key]; 
        transformedRow[column.field] = column.value; 
      });
  
      return transformedRow;
    });


    const columnsConfig = Object.keys(this.tableData[0]).map((key) => {
      const column = this.tableData[0][key];
      return {
        header: column.field,
        type: column.status, 
        excelFormat: column.status === 'date' ? 'dd/mm/yyyy' : column.status === 'number' ? '#,##0.00' : column.status === 'int' ? '#,##0' : undefined,
      };
    });

    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(excelData);

    columnsConfig.forEach((col, index) => {
      const colLetter = XLSX.utils.encode_col(index); 
  
      excelData.forEach((_, rowIndex) => {
        const cellRef = `${colLetter}${rowIndex + 2}`; 
        const cell = ws[cellRef];

        if (cell) {
          if (col.type === 'date' && cell.v) {
            cell.t = 'd'; 
            cell.z = col.excelFormat || 'dd/mm/yyyy';

            const dateObject = new Date(this.convertToMMDDYYYY(cell.v));

            dateObject.setMinutes(dateObject.getMinutes() - dateObject.getTimezoneOffset());
            cell.v = dateObject; 
          } else if (col.type === 'number' && cell.v) {
            cell.t = 'n'; 
            cell.z = col.excelFormat || '#,##0.00'; 
            cell.v = parseFloat(cell.v); 
          } else {
            cell.t = 's'; 
          }
        }
      });
    });


    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Datos');
    var fileName = this.report.reportData.name;
    if(this.report.reportData.reportType === 'NIIF') {
      fileName = this.report.reportData.name + "_" + this.translateService.instant('reportsWizard.niifTypes.' + this.formData.type);
    }

    XLSX.writeFile(wb, fileName + '_export_' + this.datePipe.transform(new Date(), 'yyyyMMddHHmmss') + '.xlsx');

  }

  //mapping taula HTML
  formatTableData(tableData: any[]): any[] {
    return tableData.map(obj => {
      let newTableData = {};
      for (let key in obj) {
        if (obj.hasOwnProperty(key)) {
          let field = key;
          let value = obj[key].value;
          newTableData[field] = value;
        }
      }
      return newTableData;
    });
  }
  //mapping EXCEL
  formatTableDataExcel(tableData: any[]): any[] {
    return tableData.map(obj => {
      let newTableData = {};
      for (let key in obj) {
        if (obj.hasOwnProperty(key)) {
          let field = obj[key].field;
          let value = obj[key].value;
          newTableData[field] = value;
        }
      }
      return newTableData;
    });
  }


  //es fa un custom sort per ordenar les columnes tipus date i integer, per defecte no funcionen
  customSort(event: SortEvent) {
    event.data.sort((data1, data2) => {
      let value1 = data1[event.field];
      let value2 = data2[event.field];
      let result = null;
      if (this.isInteger(value1) && typeof this.isInteger(value2)) {
        result = value1 - value2;
      }
      else if (this.isValidDate(value1) && this.isValidDate(value2)) {
        let date1 = new Date(this.parseDate(value1));
        let date2 = new Date(this.parseDate(value2));
        result = date1.getTime() - date2.getTime();
      }
      else if (typeof value1 === 'string' && typeof value2 === 'string') {
        result = value1.localeCompare(value2);
      }
      if (result === null) {
        if (value1 === null && value2 !== null) result = -1;
        else if (value1 !== null && value2 === null) result = 1;
        else if (value1 === null && value2 === null) result = 0;
      }

      return event.order * result;
    });
  }

  isValidDate(dateString: string): boolean {
    const date = new Date(this.parseDate(dateString));
    return !isNaN(date.getTime());
  }

  isInteger(value: string): boolean {
    return /^\d+$/.test(value);
  }

  parseDate(dateString): string {
    const parts = dateString.split("/");
    return `${parts[2]}-${parts[1]}-${parts[0]}`;
  }
  
  convertToMMDDYYYY(dateStr: string): string {
    const [day, month, year] = dateStr.split('/');
    return `${month}/${day}/${year}`;
  }

  generateConsumptionReport() {
    const formattedStartDate = this.formatDate(this.startDateFines);
    const formattedEndDate = this.formatDate(this.endDateFines);
    
    if (!formattedStartDate || !formattedEndDate) {
      alert(this.translateService.instant('reportsWizard.dateNotSelected')); // Consider a more user-friendly notification method
      return;
    }

    const yearDifference = this.validateDates(formattedStartDate, formattedEndDate);


    if(yearDifference > 1){
      alert(this.translateService.instant('reportsWizard.maxDate'));
      return;
    }


    const filters = this.processFilters(this.formData);

    filters['startDate'] = [formattedStartDate];
    const date = new Date(formattedEndDate); 
    date.setHours(23, 59, 59, 999); 
    filters['endDate'] = [date.toISOString()]; 

    const parameters = this.processParameters(this.formData.parameters);
    this.reportRequest = this.prepareReportRequest(this.report.reportData.reportType, filters, parameters);

    this.sendReportRequest(this.reportRequest);
  }

  validateDates(start, end) {
    const startDate = new Date(start);
    const endDate = new Date(end);
 
    let yearDifference = endDate.getFullYear() - startDate.getFullYear();    
    if (
        endDate.getMonth() < startDate.getMonth() || 
        (endDate.getMonth() === startDate.getMonth() && endDate.getDate() < startDate.getDate())
    ) {
        yearDifference--;
    }

    return yearDifference;
}

}

